var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "div",
        {
          staticClass: "card topic__content",
          on: {
            click: function ($event) {
              _vm.open = true
            },
          },
        },
        [_vm._t("trigger")],
        2
      ),
      _vm._v(" "),
      _vm.open
        ? _c("learning-goals-for-block-modal", {
            attrs: {
              "stream-code": _vm.streamCode,
              blocks: _vm.blocks,
              "block-content-path": _vm.blockContentPath,
            },
            on: {
              close: function ($event) {
                _vm.open = false
              },
            },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }